<template>
  <div>
    <div class="login_box">
      <div class="main_box">
        <div class="title clearfix">
          <span class="lang_login">{{$t('menu.login')}}</span>
          <router-link to="/register" class="fr lang_userinfo3" tag="a">{{$t('menu.userinfo3')}} ></router-link>
        </div>
        <div class="xcontent">
          <div class="box">
            <div class="row choose_type">
              <div class="col-md-6 col-xs-6" v-for="(item,index) in typeList" :key="index"><span class="select" v-bind:class="{active:index==defaultType}" @click="chooseType(index)"></span>{{item.name}}</div>
              <!-- <div class="col-md-6"><span class="select"></span>个人登录</div> -->
            </div>
            <div>
              <div class="input_box"><span class="lang_userinfo1">用户名：</span><input type="text" placeholder="请输入用户名" v-model="formData.accountName"></div>
              <div class="input_box"><span class="lang_userinfo2">密 码：</span><input type="password" placeholder="请输入密码" v-model="formData.accountPwd"></div>
              <div class="ar"><router-link to="/forget-pwd" tag='a'><span class="lang_forgetpwd">{{$t('menu.forgetpwd')}}</span>?</router-link></div>
              <div class="xbtn lang_login" @click="getLogin">{{$t('menu.login')}}</div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      apiPath: "",
      name: "",
      typeList: [{ name: "企业登录" }, { name: "个人登录" }],
      defaultType: 0,
      info: {},
      isLogin: "",
      isMold: 0,
      formData: {
        type: 1,
        accountName: '',
        accountPwd: ''
      }
    };
  },
  methods: {
    chooseType: function(index) {
      this.defaultType = index;
    },
    getLogin: function() {
      var that = this;
      if (this.formData.accountName == "") {
        layer.msg("用户名不能为空", {
          time: 1500
        });
        return;
      } else if (this.formData.accountPwd == "") {
        layer.msg("密码不能为空", {
          time: 1500
        });
        return;
      }

      if(this.defaultType == 0){
        this.formData.type = 1
      }else if(this.defaultType == 1){
        this.formData.type = 3
      }
      this.$http.post(this,'/noAuth/user/login',this.$Qs.stringify(this.formData)).then(res=>{
        if(res){
          layer.msg("登录成功！", {
            time: 1000
          });
          console.log(res.data.account,'res.data.account');
          this.$router.push('/');
          localStorage.setItem('token',res.data.access_token);
          localStorage.setItem("username", res.data.account.accountName);
          localStorage.setItem("id", res.data.account.id);
          localStorage.setItem("type", res.data.account.type); //1园区企业  2非园区企业  3个人
          localStorage.setItem("cmpName", res.data.account.realName);
          this.$http.setToken();
          if(res.data.company){
            localStorage.setItem("logo", res.data.company.companyLogo);
          }
          setTimeout(()=>{
            window.location.reload();
          },1000) 
          // if (this.isMold == 1 && this.defaultType==0) {
          //   setTimeout(
          //     window.sessionStorage.setItem("enterCenterType",0),             
          //     this.$router.push({path:'/enter-center'}),
          //     location.reload(),
          //     100
          //   );
          // }if (this.isMold == 1 && this.defaultType==1) {
          //   setTimeout(
          //     window.sessionStorage.setItem("personCenterType",0),             
          //     this.$router.push({path:'/person-center'}),
          //     location.reload(),
          //     100
          //   );
          // } else {
          //   setTimeout(()=>{
          //     this.$router.push('/');
          //     location.reload();
          //   }, 100);
          // }
        }
      })
    }
  },
  created: function() {
    this.isMold = this.$route.query.wechat;
    console.log(this.isMold,"this.isMold");
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/login.vue